/*
 * Target Archery – hover behaviour + animation timing for Dawn's mega menu and search.
 * Replaces the former inline hover script in sections/header.liquid.
 * - Opens a mega menu on hover, keeps the panel open when moving to another category
 * - Plays the close animation before removing [open]
 * - Shows the blurred overlay below the header
 */
(() => {
  const menus = [...document.querySelectorAll('.header__inline-menu details')];
  const overlay = document.querySelector('[data-ta-menu-overlay]');
  const headerWrapper = document.querySelector('.header-wrapper');
  const CLOSE_MS = 300;
  let closeTimer = null;
  let current = null;

  const setOverlayTop = () => {
    if (!overlay || !headerWrapper) return;
    const bottom = Math.max(0, Math.round(headerWrapper.getBoundingClientRect().bottom));
    overlay.style.setProperty('--ta-overlay-top', `${bottom}px`);
  };

  // The search modal brings its own (now blurred) overlay, so this one is only for the mega menu
  const updateOverlay = () => {
    if (!overlay) return;
    const visible = current && !current.classList.contains('is-closing');
    if (visible) setOverlayTop();
    overlay.classList.toggle('is-visible', !!visible);
  };

  const open = (details) => {
    clearTimeout(closeTimer);
    const switching = current && current !== details && current.hasAttribute('open');
    menus.forEach((m) => {
      if (m !== details && m.hasAttribute('open')) {
        m.classList.remove('is-closing', 'is-switch');
        m.removeAttribute('open');
      }
    });
    details.classList.remove('is-closing');
    details.classList.toggle('is-switch', !!switching);
    if (!details.hasAttribute('open')) details.setAttribute('open', '');
    current = details;
    updateOverlay();
  };

  const close = (details, immediately = false) => {
    if (!details.hasAttribute('open')) return;
    clearTimeout(closeTimer);
    if (immediately) {
      details.classList.remove('is-closing', 'is-switch');
      details.removeAttribute('open');
      if (current === details) current = null;
      updateOverlay();
      return;
    }
    details.classList.add('is-closing');
    details.classList.remove('is-switch');
    updateOverlay();
    closeTimer = setTimeout(() => {
      details.classList.remove('is-closing');
      details.removeAttribute('open');
      if (current === details) current = null;
      updateOverlay();
    }, CLOSE_MS);
  };

  menus.forEach((details) => {
    details.addEventListener('mouseenter', () => open(details));
    details.addEventListener('mouseleave', (e) => {
      // Moving straight onto another top-level item: let that one take over without closing
      const next = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.header__inline-menu details');
      if (next && next !== details) return;
      close(details);
    });
    // Clicks / keyboard (Dawn toggles [open] itself): keep overlay and state in sync
    details.addEventListener('toggle', () => {
      if (details.hasAttribute('open')) {
        if (current !== details) open(details);
      } else if (current === details && !details.classList.contains('is-closing')) {
        current = null;
        updateOverlay();
      }
    });
  });

  if (overlay) {
    overlay.addEventListener('mouseenter', () => current && close(current));
    overlay.addEventListener('click', () => current && close(current, true));
  }

  // Opening the search closes an open mega menu
  document.querySelectorAll('.header__search details').forEach((d) => {
    d.addEventListener('toggle', () => {
      if (d.hasAttribute('open') && current) close(current, true);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && current) close(current);
  });
  window.addEventListener('scroll', () => overlay && overlay.classList.contains('is-visible') && setOverlayTop(), {
    passive: true,
  });
})();
